module.exports = __webpack_public_path__ + "img/share.711c458a.png";